import TeamFiltersContainer from './TeamFiltersContainer';

export default TeamFiltersContainer;
